import PageContainer from '@/views/base/page.vue'
export default [
  {
    path: '/index',
    component: PageContainer,
    children: [
      {
        path: '/news',
        component: () => import('@/views/news/index.vue'),
        meta: { title: '热点资讯', keepAlive: true, needAuth: false }
      }
    ]
  }
]
